import { Modal } from "@gravity-ui/uikit";
import { ExportJobDto } from "definitions/exporter";

import { ExportLogsContent } from "../ExportLogsContent";

interface ExportLogsModalProps {
  open: boolean;
  job: ExportJobDto | null;
  metadata: string;
  onClose: () => void;
}

export const ExportLogsModal = ({
  open,
  job,
  metadata,
  onClose,
}: ExportLogsModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ExportLogsContent
        isModal={true}
        onClose={onClose}
        job={job}
        metadata={metadata}
      />
    </Modal>
  );
};
